import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import EducationSection from './EducationSection';
import BasicInfoSection, { BasicInfo } from './BasicInfoSection';
import WorkExperienceSection from './WorkExperienceSection';
import { Education } from './EducationRecord';
import { WorkExperience } from './WorkExperienceRecord';
import { useParams } from 'react-router-dom';
import APICaller, { MethodType } from '../common/APICaller';
import { useLoading } from '../../contexts/LoadingContext';

const emptyBasicInfo: BasicInfo = {
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  city: '',
  province: '',
  country: '',
  timezone: '',
  immigrationStatus: '',
  lgbtIdentity: '',
  ageEligibility: '',
  workEligibility: '',
  genderIdentity: '',
  visibleMinority: '',
  indigenousPerson: '',
  disability: '',
  resumeAvailable: false,
  transcriptFileName: null,
  linkedIn: '',
  portfolio: '',
  github: '',
  publishedPapers: '',
  wageSubsidy: '',
  wasCapstone: false,
};

const ApplicantProfileView: React.FC = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>(emptyBasicInfo);
  const [educationRecords, setEducationRecords] = useState<Education[]>([]);
  const [workExpRecords, setWorkExpRecords] = useState<WorkExperience[]>([]);
  const { applicantId } = useParams();
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchApplicantProfile = async () => {
      try {
        showLoading('Loading applicant profile...');
        const res = await APICaller(`/profile/review/applicants/${applicantId}`, MethodType.GET);
        if (!res.applicantProfile) {
          return;
        }
        const data = res.applicantProfile;
        const email = res.email;
        const BasicInfoData: BasicInfo = {
          id: data.id,
          firstName: data.firstName,
          lastName: data.lastName,
          email,
          city: data.city,
          province: data.province,
          country: data.country,
          timezone: data.timezone,
          immigrationStatus: data.immigrationStatus,
          lgbtIdentity: data.lgbtIdentity,
          ageEligibility: data.ageEligibility,
          workEligibility: data.workEligibility,
          genderIdentity: data.genderIdentity,
          visibleMinority: data.visibleMinority,
          indigenousPerson: data.indigenousPerson,
          disability: data.disability,
          resumeAvailable: data.resumeFileName != null,
          transcriptFileName: data.transcriptFileName,
          linkedIn: data.linkedIn,
          portfolio: data.portfolio,
          github: data.github,
          publishedPapers: data.publishedPapers,
          wageSubsidy: data.wageSubsidy,
          wasCapstone: data.wasCapstone || false,
        };
        // console.log(BasicInfoData);
        setBasicInfo(BasicInfoData);
        setEducationRecords(data.education);
        setWorkExpRecords(data.workExp);
      } catch (error) {
        console.error('Error loading applicant profile:', error);
      } finally {
        hideLoading();
      }
    };

    fetchApplicantProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantId]);

  return (
    <Grid
      container
      item
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      xs={8}
      md={8}
      spacing={8}
      sx={{ paddingRight: '15vw', borderColor: 'red', marginBottom: '5vh', paddingTop: '6vh' }}
    >
      <BasicInfoSection
        viewMode={true}
        data={basicInfo}
        resumeAvailable={basicInfo.resumeAvailable}
      />
      <EducationSection viewMode={true} data={educationRecords} />
      <WorkExperienceSection viewMode={true} data={workExpRecords} />
    </Grid>
  );
};

export default ApplicantProfileView;
